import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postResendVerificationCode
 *
 * Resend verification code.
 *
 * @param email Email address to which the verification code will be sent.
 * @returns Authentication code email transmission result.
 */

export const postResendVerificationCode = async (email: string) => {
  try {
    const res = await axios.post(
      getAPIRoot(APIRoutes.post.resend),
      {
        sonic_email: email,
      },
      {
        headers: {
          "Content-Type": "application/form-data; charset=UTF-8",
        },
      }
    );

    return res.data.result;
  } catch (error) {
    return false;
  }
};
